import { PagedResults } from "../../interfaces/genericResponse/GenericResponse";
import {  GetTaskExtentionDetailsResDto, TaskExtensionExclusionDto, TaskExtensionExclusionRequestDto, TemplatesByTypeDto } from "../../interfaces/TaskExtentionDtos/taskExtention.model";
import { ApiResponse } from "../../interfaces/genericResponse/GenericResponse";

export const createTaskExclusionAsync = async (
    token: string,
    request : TaskExtensionExclusionRequestDto
): Promise<ApiResponse<boolean>> => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin/task-extension-exclusions/CreateTaskExtension`;

    const response = await fetch(
        url,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(request)
        }
    );

    const data = await response.json();
    return data;
};


export const GetTemplatesByTypeAsync = async (
    token: string,
    type : string
): Promise<ApiResponse<TemplatesByTypeDto[]>> => {
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin/task-extension-exclusions/get-by-type?type=${encodeURIComponent(type)}`;

    const response = await fetch(
        url,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }
    );

    const data = await response.json();
    return data;
};


export const GetTaskExtentionExclusionAsync = async (
  token: string,
  pageNumber: number = 1,
  pageSize: number = 500
): Promise<ApiResponse<PagedResults<TaskExtensionExclusionDto>>> => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/admin/task-extension-exclusions?PageNumber=${pageNumber}&PageSize=${pageSize}`;

    const response = await fetch(
        url,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }
    );

    const data = await response.json();
    return data;
};

export const GetTaskExtentionDetailsAsync = async (
  token: string,
  administrative_transaction_request_id: number
): Promise<ApiResponse<GetTaskExtentionDetailsResDto>> => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/admin/task-extension-exclusions/${administrative_transaction_request_id}/TaskExtentionDetails`;

    const response = await fetch(
        url,
        {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }
    );

    const data = await response.json();
    return data;
};

export const DeleteTaskExtentionExclusionAsync = async (
  token: string,
  taskExtentionExclusionId: string
): Promise<ApiResponse<boolean>> => {
  const url = `${process.env.REACT_APP_API_BASE_URL}/admin/task-extension-exclusions/${taskExtentionExclusionId}/DeleteTaskExtentionExclusion`;

    const response = await fetch(
        url,
        {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        }
    );

    const data = await response.json();
    return data;
};